import PaymentCategories from '../../../../enums/PaymentCategories';

export default state => state.payment.category || PaymentCategories.NONE;
